import { render, staticRenderFns } from "./ProfileTabs.vue?vue&type=template&id=09a4f7bd&scoped=true&"
import script from "./ProfileTabs.vue?vue&type=script&lang=js&"
export * from "./ProfileTabs.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTabs.vue?vue&type=style&index=0&id=09a4f7bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a4f7bd",
  null
  
)

export default component.exports